<template>
  



















  






















  <div class="container-lg ps-3 pe-3   pt-3 pb-3  pt-md-4 pb-md-4    pt-lg-5 pb-lg-5    pt-xl-0   ps-md-5   pe-md-5 home">


  












<div class="container-lg homeSection gx-0"> 
  <div class="video-wrapper"> 
    <video class="video" autoplay loop muted playsinline> 
      <source src="../assets/game-videoOutline1low.mp4" type="video/mp4"> 
      Your browser does not support the video tag. 
    </video> 
  </div> 
    <p class="home-subtitle">Welcome To</p>
    
    <h1 class="home-title fw-bold">GAME ZONE</h1> 
</div>





  


  

































</div>



<div class="text-center bg-light allwidth">








<div class="container-lg ps-3 pe-3     pt-1 pb-0   pt-lg-5 pb-lg-4       ps-md-5  pe-md-5 home" >


  



  <div class="rowhome">
  <div class="col-xl-4 col-lg-5 col-md-6 col-sm-7 col-10 mr-auto wpb_column vc_column_container vc_col-sm-6 col-12">
    <div class="vc_column-inner">
      <div class="wpb_wrapper">
        <h1 style="text-align: left" class="vc_custom_heading h2 mb-0 text__fade-horizontal home__heading-intro animated">
          <div class="text__fade-horizontal-wrap" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
      
            <u>Can't wait</u> to have some fun? The Game Zone has you covered!
          </div>
        </h1>
        <p class="mt-3" style="text-align: left; font-style: italic;"><b>D</b>on't <b>D</b>elay, <b>P</b>lay <b>T</b>oday!</p>
        <div class="vstack gap-2 col-md-5">
 
</div>

      </div>
    </div>
  </div>
  <div class="col-xl-3 col-lg-3 col-md-4 col-10 align-self-end text-lg-left text-md-right wpb_column vc_column_container vc_col-sm-6 col-12">
    <div class="vc_column-inner">
      <div class="wpb_wrapper">

        <router-link
  to="/about"
  class="d2__button service__button text-black row text__fade-horizontal location__href animated"  
          data-screen_offset=".15"
        >



  <div class="service__button-content">


  <span class="service__button-text">  
    <a class="d2__button-text" style="color: black;">
      Understand The Mission
    </a>
  </span>

  <span class="service__button-icon">
    <a class="d2__button-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="blue" class="bi bi-caret-right-square ms-4" viewBox="0 0 16 16">
<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/> <path d="M5.795 12.456A.5.5 0 0 1 5.5 12V4a.5.5 0 0 1 .832-.374l4.5 4a.5.5 0 0 1 0 .748l-4.5 4a.5.5 0 0 1-.537.082z"/> </svg>
          </a>
    
  </span>



  </div>

  <a class="d2__button-shadow">
  </a>

</router-link>
      </div>
    </div>
  </div>
</div>



















</div>


</div>






















<div class="container-lg ps-3 pe-3     pt-1       ps-md-5  pe-md-5 home1">










  



















<h2 class="mt-4 mt-md-5 pt-5 pb-3">Play Classic Games</h2>


    <p class="ps-1 pt-0 pb-3 pe-1 mt-3 mb-4      ps-md-3   pe-md-3        ps-lg-5  pe-lg-5">Relax and rejuvenate with these nostalgic games that provide a bit of entertainment and a change of pace from work stress. With just a few minutes, you can challenge yourself and give your brain a break from demanding tasks. Play these games solo or challenge friends and colleagues to some friendly competition.</p>



    <div class="row justify-content-center">
        <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 justify-content-center p-2">
          <div class="card m-auto">
            <video class="w-100 h-100 top-0 start-0 rounded-top" style="position: relative;" autoplay loop muted playsinline>
              <source src="../assets/number.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <div class="card-body m-4">
              <h5 class="card-title mb-2 mt-1 fw-bold">Reaction Timer</h5>
              

              <p class="card-text my-3">Test your reaction time. Challenge your friends and colleagues to beat your score!</p>

              
              

              <router-link 
                class="btn btn-outline-primary my-2 px-5 shadow-sm"
                to="/ReactionTimerGame">

                <i class="bi bi-caret-right-fill me-1"></i>
                Play
              </router-link>




            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 justify-content-center p-2">
          <div class="card m-auto">
            <video class="w-100 h-100 top-0 start-0 rounded-top" style="position: relative;" autoplay loop muted playsinline>
              <source src="../assets/cards.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <div class="card-body m-4">
              <h5 class="card-title mb-2 mt-1 fw-bold">War Card Game</h5>


              
              

              <p class="card-text my-3">Experience the excitement of the classic card game War. Test your luck and strategy.</p>


              



              <router-link 
                class="btn btn-outline-primary my-2 px-5 shadow-sm"
                to="/WarGame">

                <i class="bi bi-caret-right-fill me-1"></i>
                Play
              </router-link>





            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 justify-content-center p-2">
          <div class="card m-auto">
            <video class="w-100 h-100 top-0 start-0 rounded-top" style="position: relative;" autoplay loop muted playsinline>
              <source src="../assets/TicTacToe.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <div class="card-body m-4">
              <h5 class="card-title mb-2 mt-1 fw-bold">Tic Tac Toe</h5>

              <p class="card-text my-3">Play the timeless game of Tic Tac Toe. Can you outsmart your opponents and claim victory?</p>
              
              



               <router-link 
                class="btn btn-outline-primary my-2 px-5 shadow-sm"
                to="/TicTacToeGame">

                <i class="bi bi-caret-right-fill me-1"></i>
                Play
              </router-link>




            </div>
          </div>
        </div>
      </div>




  

















    
      



















      
      














    
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>












<style>
.video-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%; /* 16:9 aspect ratio */
}

.video {
  position: absolute;   
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 500px;
  width: 100%;   
  object-fit: cover;
}

.home-subtitle, 
.home-title {
  position: absolute;   
  top: 50%;
  left: 50%;  
  color: white;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.7);
}

.home-subtitle {
  transform: translate(-50%, -99%);     
  font-size: 1.4vw;    
  letter-spacing: 0.08rem;
} 

.home-title {
  transform: translate(-50%, -1%);
  font-size: 3.75vw;  
  letter-spacing: 0.03rem;  
}















.rowhome {
    margin-top: 3rem;
    margin-bottom: 5rem;
    display: flex;
    flex-wrap: wrap;
    margin-right: auto!important;
    margin-left: auto!important;
    
}

@media (max-width: 768px) {
  .rowhome {
    margin-bottom: 4.5rem;
}
}


@media (max-width: 667px) {
  .rowhome {
    margin-bottom: 4.5rem;
}
}






.rowhome .col-md-6 {
    flex: 0 0 60%;
    max-width: 60%;
    padding-right: 150px;
    
}

@media (max-width: 768px) {
  .rowhome .col-md-6 {
    padding-right: 50px;
    
}
}

@media (max-width: 600px) {
  .rowhome .col-md-6 {
    padding-right: 5px;
    
}
}























.rowhome .col-md-4 {
    flex: 0 0 40%;
    max-width: 40%;
    margin-bottom: 9px;
}

.align-self-end {
    align-self: flex-end!important;
}

.text-md-right {
    text-align: right!important;
}






.vc_custom_heading u {
    text-decoration-color: red;
  }





.allwidth {
  background-image: url('../assets/vortex-long-5opacity.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 3.75em;
  padding-bottom: 3em;
}

@media (max-width: 768px) {
  .allwidth {
    padding-top: 2.5em;
    padding-bottom: 1.25em;
}
}

@media (max-width: 670px) {
  .allwidth {
    padding-top: 2em;
    padding-bottom: 0.01em;
}
}


















.home1 {
  padding-bottom: 6em;
}


@media (max-width: 768px) {
   .home1 {
     padding-bottom: 5em;
}
}

@media (max-width: 667px) {
  .home1 {
    padding-bottom: 3.5em;
}
}









</style>
